export enum ColumnUnitsId {
  PATH_WIDTHS_IN_MM_COL_ID = 'pathWidthsInMM',
  WEFT_DENSITY_COL_ID = 'weftDensity',
  PICK_DENSITY_COL_ID = 'pickDensity',
  REED_DENSITY_COL_ID = 'reedDensity',
  PRACTICAL_PICK_DENSITY_COL_ID = 'practicalPickDensity',
  LENGTH_IN_MM_COL_ID = 'lengthInMM',
  WIDTH_IN_MM_COL_ID = 'widthInMM'
}
